'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { InputField, InputFieldProps } from '../input-field/input-field.tsx';
import { useCreditCardFields } from './utils.ts';
export type CardNameFieldProps = Omit<InputFieldProps, 'maskOptions' | 'maxLength' | 'minLength' | 'pattern' | 'placeholder' | 'prefix' | 'type' | 'validate'>;
export const CardNameField: React.FC<CardNameFieldProps> = t0 => {
  const $ = _c(19);
  let fieldProps;
  let help;
  if ($[0] !== t0) {
    ({
      help,
      ...fieldProps
    } = t0);
    $[0] = t0;
    $[1] = fieldProps;
    $[2] = help;
  } else {
    fieldProps = $[1];
    help = $[2];
  }
  const {
    validator
  } = useCreditCardFields();
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["checkout"];
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[4] !== t) {
    t2 = t("checkout:form.billingFields.nameOnCardLabel");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t) {
    t3 = t("checkout:form.billingFields.nameOnCardNumberError");
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = {
      message: t3
    };
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t || $[11] !== validator) {
    t5 = value => validator.cardholderName(value).isValid ? true : t("checkout:form.billingFields.nameOnCardError");
    $[10] = t;
    $[11] = validator;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== fieldProps || $[14] !== help || $[15] !== t2 || $[16] !== t4 || $[17] !== t5) {
    t6 = <InputField autoComplete="cc-name" label={t2} help={help} removeCardNumbers={t4} validate={t5} {...fieldProps} />;
    $[13] = fieldProps;
    $[14] = help;
    $[15] = t2;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
};